export default __webpack_public_path__ + "assets/Excel_Share.png";